import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, AbstractControlDirective} from '@angular/forms';

@Component({
  selector: 'show-errors-app',
  templateUrl: './show-errors-app.component.html',
  styleUrls: []
})
export class ShowErrorsAppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  private static readonly errorMessages = {
    'required': () => 'Este campo es requerido',
    'minlength': (params) => 'La cantidad mínima de caracteres es ' + params.requiredLength,
    'maxlength': (params) => 'La cantidad máxima permitida de caracteres es ' + params.requiredLength,
    'pattern': (params) => 'El patrón requerido es: ' + params.requiredPattern,
    /*'pattern': () => 'El patrón requerido es: user@domain.com',*/
    'years': (params) => params.message,
    'countryCity': (params) => params.message,
    'requiredName': (params) => params.message,
    'telephoneNumbers': (params) => params.message,
    'telephoneNumber': (params) => params.message
  };

  @Input()
  private control: AbstractControlDirective | AbstractControl;

  shouldShowErrors(): boolean {
    return this.control &&
      this.control.errors &&
      (this.control.dirty || this.control.touched);
  }

  listOfErrors(): string[] {
    return Object.keys(this.control.errors)
      .map(field => this.getMessage(field, this.control.errors[field]));
  }

  private getMessage(type: string, params: any) {
    if (type === 'pattern' && params.requiredPattern === '^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{1,5}$') {
      return 'El patrón requerido es: user@domain.com';
    }
    if (type === 'pattern' && params.requiredPattern === '^[0-9]{8}$'){
      return 'Ingrese solo numeros: 0-9';
    }
    if (type === 'pattern' && params.requiredPattern === '^[0-9]{9}$'){
      return 'Ingrese solo numeros: 0-9';
    }
    return ShowErrorsAppComponent.errorMessages[type](params);
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/show-errors-app/show-errors-app.component.ts